// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"50a01345","144":"54b190e6","247":"e97f8d98","295":"62f9e54e","361":"dd396f64","945":"abe0c1e0"}[chunkId] + ".css";
};